import ErrorPage from '@/components/errors/ErrorPage';

export default function ServerError() {
  return (
    <ErrorPage
      code="500"
      emoji="🛠️"
      title="Server error"
      description="The control panel backend failed while handling your request."
      details="Check server logs, API health, and infrastructure status. If this persists, reload the page after the backend recovers."
    />
  );
}
